import { render, staticRenderFns } from "./IndexBottom.vue?vue&type=template&id=4f961518&scoped=true&"
import script from "./IndexBottom.vue?vue&type=script&lang=js&"
export * from "./IndexBottom.vue?vue&type=script&lang=js&"
import style0 from "./IndexBottom.vue?vue&type=style&index=0&id=4f961518&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f961518",
  null
  
)

export default component.exports